import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import * as moment from 'moment';
import { DataService } from '../data/data.service';
import { getClientConfig } from '@config/client-config';

@Injectable()
export class MaterialCustomDateAdapter extends NativeDateAdapter {
  private env = getClientConfig().environments;
  constructor(private dataService: DataService, platform: Platform) {
    super('en-US', platform);
  }
  public format(date: Date): string {
    const format = this.dataService._currentDateFormat.getValue().split(this.env.isGeotabEnv ? / [Hh]/ : ' ')[0];
    const result = moment(date).format(format);
    return result;
  }
}
